import React from 'react'
export default function EssentialCompanionIcon() {
    return (
        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.06944 10.1154H3V9.03209H6.06944V5.96265H7.15278V9.03209H10.2222V10.1154H7.15278V13.1849H6.06944V10.1154Z" fill="black"/>
            <path d="M14.4517 15.1475V7.06367L12.2222 7.8675V5.6835L16.8632 4V15.1475H14.4517Z" fill="black"/>
        </svg>

    )
}


